import React from 'react'
import { FormattedMessage } from 'react-intl'
import SidebarWidget from './SidebarWidget'
import styles from './_sidebarWidget.css'
import { Button } from 'components/util'

import nikePlus from 'images/nike_plus.png'
import garmin from 'images/garmin_device.png'
import polar from 'images/polar.png'
import powertap from 'images/powertap.png'

export default function ImportWorkoutsWidget () {
  return (
    <SidebarWidget>
      <h3>
        <FormattedMessage
          id='workout.create.aside.integrate_title'
          defaultMessage='Integrate all your workout data'
        />
      </h3>
      <p className={styles.sidebarContent}>
        <FormattedMessage
          id='workout.create.aside.integrate_content'
          defaultMessage='Bring in all your past data to track your progress over time'
        />
      </p>
      <a href='/workout/import/dashboard/'>
        <div className={styles.sidebarImageGrid}>
          <div className={styles.sidebarImageItem}><img src={nikePlus} /></div>
          <div className={styles.sidebarImageItem}><img src={garmin} /></div>
          <div className={styles.sidebarImageItem}><img src={polar} /></div>
          <div className={styles.sidebarImageItem}><img src={powertap} /></div>
        </div>
      </a>
      <div className={styles.sidebarCTA}>
        <a href='/workout/import/dashboard/'>
          <Button type='secondary' size='small'>
            <FormattedMessage
              id='workout.create.aside.integrate_link'
              defaultMessage='Import Workouts'
            />
          </Button>
        </a>
      </div>
    </SidebarWidget>
  )
}




// WEBPACK FOOTER //
// ./src/components/sidebar/ImportWorkouts.jsx